import { useState } from 'react';

// ==============================|| HOOK - EXCLUSIVE ACCORDION ||============================== //
// V seznamu accordionů smí být rozbalený vždy jen jeden (2026-08-23,
// explicitní požadavek uživatele - "vždy bude aktivní jen jeden, ostatní
// sbalit", "platí napříč celou appkou"). Použití:
//
//   const [expandedId, handleAccordionChange] = useExclusiveAccordion();
//   <Accordion expanded={expandedId === item.id} onChange={handleAccordionChange(item.id)}>
export default function useExclusiveAccordion() {
  const [expandedId, setExpandedId] = useState(null);
  const handleChange = (id) => (event, isExpanded) => setExpandedId(isExpanded ? id : null);

  return [expandedId, handleChange];
}
